import React from 'react';
import PropTypes from 'prop-types';
import { ProductCard } from './ProductCard';

export const ProductsGridContent = ({ products }) => {
    return (
        <div className="row">
            {products.map((product) => (
                <div key={product.id} className="col-sm-6 col-md-4 col-lg-3 mb-4">
                    <ProductCard key={product.id} product={product} />
                </div>
            ))}
        </div>
    );
};

ProductsGridContent.propTypes = {
    products: PropTypes.array
};
